import { createFileRoute } from '@tanstack/react-router';
import { whatsNewQuery } from '../../api/queries';
import { WhatsNewPage } from '../../features/whats-new/WhatsNewPage';

export const Route = createFileRoute('/_app/whats-new')({
  loader: ({ context }) => context.queryClient.query(whatsNewQuery),
  component: WhatsNewPage,
});
